import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Tag } from 'antd';
import { Icon } from 'ui';

const TagWrapper = styled(Tag)`
  height: 15px;
  text-align: center;
  margin-right: 0;
  margin-left: 3px;
  line-height: 13px;
  text-transform: uppercase;
  font-weight: 600;
  padding: 0 2px;
  ${p => p.large && `
    height: 18px;
    font-size: 14px;
    line-height: 17px
  `}
`;
const WhiteIcon = styled(Icon)`
  color: white !important;
`;

const StyledWhiteIcon = styled(WhiteIcon)`
  margin-right: 2px;
`;


const BlockTag = ({
  color,
  tagIcon,
  customIcon,
  text,
  shortText,
  showShortText,
  showIconOnly,
  large = false,
  lightIcon = false,
}) => {
  let textToShow = text;
  if (showShortText && shortText) {
    textToShow = shortText;
  }

  const renderIcon = () => {
    if (!text) {
      return <WhiteIcon type={tagIcon} light={lightIcon} customIcon={customIcon} />;
    }
    if (tagIcon) {
      if (showIconOnly) {
        return <WhiteIcon type={tagIcon} light={lightIcon} customIcon={customIcon} />;
      }
      return <>
        <StyledWhiteIcon type={tagIcon} light={lightIcon} customIcon={customIcon} /> {textToShow}
      </>;
    }
    return textToShow;
  };
  return (
    <TagWrapper color={color} large={large}>
      {renderIcon()}
    </TagWrapper>
  );
};

BlockTag.propTypes = {
  color: PropTypes.string,
  tagIcon: PropTypes.string,
  text: PropTypes.string,
  shortText: PropTypes.string,
  showShortText: PropTypes.bool,
  showIconOnly: PropTypes.bool,
  large: PropTypes.bool,
  lightIcon: PropTypes.bool,
  customIcon: PropTypes.bool,
};

export default BlockTag;
